import type { FreeLayoutPluginContext } from '@flowgram.ai/free-layout-editor';

/**
 * 获取画布可见区域中心在画布坐标系中的落点。
 */
export function getViewportCenterCanvasPosition(
  ctx: FreeLayoutPluginContext,
): { x: number; y: number } | undefined {
  if (typeof document === 'undefined') return undefined;

  const playgroundEl = document.querySelector<HTMLElement>('.gedit-playground')
    || document.querySelector<HTMLElement>('.gedit-playground-layer');
  const rect = playgroundEl?.getBoundingClientRect();
  if (!rect || rect.width <= 0 || rect.height <= 0) return undefined;

  return ctx.playground.config.getPosFromMouseEvent({
    clientX: rect.left + rect.width / 2,
    clientY: rect.top + rect.height / 2,
  });
}
